import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

function Footer() {
    return (
        <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-white mt-16">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    {/* Spalte 1: Über uns */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">
                            <span className="text-white">Sporty</span>
                            <span className="text-orange-500">Replay</span>
                        </h3>
                        <p className="text-gray-400 leading-relaxed">
                            Dein Marktplatz für gebrauchte Sportartikel - Nachhaltig, Regional und Günstig.
                        </p>
                    </div>

                    {/* Spalte 2: Produkte */}
                    <div>
                        <h4 className="font-semibold mb-4 text-white">Produkte</h4>
                        <ul className="space-y-2">
                            <li><Link to="/products" className="text-gray-400 hover:text-orange-500 transition-colors">Alle Produkte</Link></li>
                            <li><Link to="/my-products" className="text-gray-400 hover:text-orange-500 transition-colors">Meine Produkte</Link></li>
                            <li><Link to="/products/create" className="text-gray-400 hover:text-orange-500 transition-colors">Verkaufen</Link></li>
                        </ul>
                    </div>

                    {/* Spalte 3: Account */}
                    <div>
                        <h4 className="font-semibold mb-4 text-white">Account</h4>
                        <ul className="space-y-2">
                            <li><Link to="/login" className="text-gray-400 hover:text-orange-500 transition-colors">Anmelden</Link></li>
                            <li><Link to="/register" className="text-gray-400 hover:text-orange-500 transition-colors">Registrieren</Link></li>
                            <li><Link to="/profile" className="text-gray-400 hover:text-orange-500 transition-colors">Profil</Link></li>
                        </ul>
                    </div>

                    {/* Spalte 4: Rechtliches */}
                    <div>
                        <h4 className="font-semibold mb-4 text-white">Rechtliches</h4>
                        <ul className="space-y-2">
                            <li className="text-gray-400">✉ info@sportyreplay.de</li>
                            <li><Link to="/impressum" className="text-gray-400 hover:text-orange-500 transition-colors">Impressum</Link></li>
                            <li><Link to="/datenschutz" className="text-gray-400 hover:text-orange-500 transition-colors">Datenschutz</Link></li>
                            <li>
                                <button
                                    onClick={() => {
                                        localStorage.removeItem('cookieConsent');
                                        window.location.reload();
                                    }}
                                    className="text-gray-400 hover:text-orange-500 transition-colors"
                                >
                                    Cookie-Einstellungen
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-400 text-center md:text-left">
                        © {new Date().getFullYear()} SportyReplay. Alle Rechte vorbehalten.
                    </p>
                    <p className="text-sm flex items-center text-gray-400 mt-4 md:mt-0">
                        Made with <Heart size={16} className="mx-1 text-orange-500" /> in Bielefeld
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
